import React from 'react'
import useStore from '../../../../../StorePeople/Store'
import uploadIcon from './images/uploadSVG.svg'
import styles from './styles.module.css'

function JobTitlePeople () {
  const {
    isQueryLoading,
    setRequiredFields,
    setRecordRecency,
    setOrFields,
    setMostRecentPropertyPurchaseDate
  } = useStore()

  const onClickRealEstatePropertiesOwned = () => {
    // "query": "propertiesOwned:* AND (emails* OR phoneNumbers:*) AND dateUpdated:[2025-06-09 TO *]"
    if (isQueryLoading) return
    setRequiredFields(['propertiesOwned'])
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
    const dateString = thirtyDaysAgo.toISOString().split('T')[0]
    setRecordRecency('', dateString)
    setOrFields(['emails', 'phoneNumbers'])
    // "query": "jobTitle:(CEO OR CFO OR CTO OR CPO OR COO OR CRO OR VP OR \"Vice President\" OR director) AND (emails:* OR phoneNumbers:*)"
  }
  const onClickPropertiesRepresented = () => {
    if (isQueryLoading) return
// "query": "businessCategories:banking AND (emails:* OR phoneNumbers:*)"
    setRequiredFields(['propertiesRepresented'])
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
    const dateString = thirtyDaysAgo.toISOString().split('T')[0]
    setRecordRecency('', dateString)
    setOrFields(['emails', 'phoneNumbers'])
  }

  const onClickNewHomeowners = () => {
    // R33: New quick filter for people who purchased property in last 30 days
    // Uses mostRecentPropertyPurchaseDate >= now-30d
    if (isQueryLoading) return
    const thirtyDaysAgo = new Date()
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)
    const dateString = thirtyDaysAgo.toISOString().split('T')[0]
    setMostRecentPropertyPurchaseDate(dateString, '')
  }


  return (
    <section>
      <div className={styles.jobTitlePeopleContainer}>
        <h2 className={styles.jobTitlePeopleTitle}>Real Estate</h2>
        <div className={styles.jobTitlePeopleValues}>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickRealEstatePropertiesOwned}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>
                Contact information for new homeowners
              </span>
              <p className={styles.jobTitlePeopleText}>
                Emails and phones for people who bought a property in the last
                30 days
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickPropertiesRepresented}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>
                Contact information for brokers
              </span>
              <p className={styles.jobTitlePeopleText}>
                Emails and phones for brokers who listed a property in the last
                30 days
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
          <div
            className={`${styles.jobTitlePeopleItem} ${
              isQueryLoading ? styles.jobTitlePeopleItemDisabled : ''
            }`}
            onClick={onClickNewHomeowners}
          >
            <div>
              <span className={styles.jobTitlePeopleSpan}>
                New Homeowners (Last 30 Days)
              </span>
              <p className={styles.jobTitlePeopleText}>
                People who purchased property in the last 30 days
              </p>
            </div>
            <img
              src={uploadIcon}
              alt='upload'
              className={styles.jobTitlePeopleImg}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default JobTitlePeople
